const VALID_ENVIRONMENTS = new Set(['prod', 'stage', 'qa', 'perf']);
export class EnvironmentService {
    static getEnvironment() {
        const value = globalThis.window?.ENVIRONMENT;
        if (value && VALID_ENVIRONMENTS.has(value)) {
            return value;
        }
        return undefined;
    }
    static isEnvironment(env) {
        return EnvironmentService.getEnvironment() === env;
    }
}
